import { List } from '@mui/material';
import React from 'react';
import { useLocation } from 'react-router-dom';

import { CustomNavLink } from '../../../AppShell/components/CustomNavLink';
import { getAppBarHeight } from '../../../util/helpers';
import { getAgentHubNavItems } from '../agentHubNavItems';
import { useProvisioningPlatform } from '../provisioning';

type Props = {
  onCloseDrawer?: () => void;
};

export const AgentHubNavContent = ({ onCloseDrawer }: Props): JSX.Element => {
  const location = useLocation();
  const { platform } = useProvisioningPlatform();
  const navItems = getAgentHubNavItems(platform);

  return (
    <List
      sx={{
        paddingTop: '20px !important',
        backgroundColor: 'background.dark',
        height: {
          xs: `100vh`,
          sm: `100vh`,
          md: `calc(100vh - ${getAppBarHeight()}px)`,
        },
        overflowY: 'auto',
      }}
    >
      {navItems.map((item) => (
        <CustomNavLink
          key={item.path}
          label={item.label}
          path={item.path}
          onClick={onCloseDrawer}
          selected={location.pathname.toLowerCase() === item.path.toLowerCase()}
        />
      ))}
    </List>
  );
};
